import moment from "moment"
import {useCallback, useEffect, useRef, useState} from "react"

require("moment-timezone")

const getReturnValues = (countDown) => {
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24))
    const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000)

    return {days, hours, minutes, seconds}
}


export const useMomentCountdown = (targetDate, timezone) => {
    const [countDown, setCountDown] = useState(0)
    const intervalRef = useRef(null)

    const updateCountdown = useCallback(() => {
        const now = moment.tz(timezone)
        const target = moment.tz(targetDate, timezone)
        const diff = target.diff(now)
        setCountDown(Math.max(0, diff))
    }, [targetDate, timezone])

    useEffect(() => {
        intervalRef.current = setInterval(updateCountdown, 1000)
        updateCountdown()
        return () => clearInterval(intervalRef.current)
    }, [updateCountdown])

    const timeValues = getReturnValues(countDown)

    return {
        ...timeValues,
        isLoaded: true,
        error: null,
    }
}


